export default __webpack_public_path__ + "static/media/hk-logo.5e03e52d.png";